import React from 'react';

const ContactCreateConfirmationModal = ({ open, proposed, onConfirm, onCancel }) => {
  if (!open) return null;

  const name = `${proposed?.first_name || ''} ${proposed?.last_name || ''}`.trim() || 'this contact';
  const company = proposed?.company_name;

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <div style={styles.title}>Create contact?</div>
        <div style={styles.subtitle}>
          {company ? (
            <span>
              Create <b>{name}</b> at <b>{company}</b>?
            </span>
          ) : (
            <span>
              Create <b>{name}</b>?
            </span>
          )}
        </div>

        <div style={styles.details}>
          {proposed?.title && <div style={styles.row}><span style={styles.k}>Title</span><span style={styles.v}>{proposed.title}</span></div>}
          {proposed?.phone && <div style={styles.row}><span style={styles.k}>Phone</span><span style={styles.v}>{proposed.phone}</span></div>}
          {proposed?.email && <div style={styles.row}><span style={styles.k}>Email</span><span style={styles.v}>{proposed.email}</span></div>}
        </div>

        <div style={styles.actions}>
          <button onClick={onCancel} style={{ ...styles.btn, ...styles.btnSecondary }}>Cancel</button>
          <button onClick={onConfirm} style={{ ...styles.btn, ...styles.btnPrimary }}>Confirm</button>
        </div>

        <div style={styles.hint}>Tip: you can also say “confirm” or “cancel”.</div>
      </div>
    </div>
  );
};

const styles = {
  backdrop: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: '16px',
  },
  modal: {
    width: '100%',
    maxWidth: '420px',
    background: '#0b1220',
    border: '1px solid #1f2937',
    borderRadius: '14px',
    padding: '18px',
    boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
    color: '#e5e7eb',
  },
  title: { fontSize: '18px', fontWeight: 700, marginBottom: '8px' },
  subtitle: { fontSize: '14px', color: '#cbd5e1', marginBottom: '14px', lineHeight: 1.4 },
  details: {
    background: '#0f172a',
    border: '1px solid #1f2937',
    borderRadius: '12px',
    padding: '12px',
    marginBottom: '14px',
  },
  row: { display: 'flex', justifyContent: 'space-between', gap: '12px', padding: '6px 0' },
  k: { color: '#94a3b8', fontSize: '12px' },
  v: { color: '#e2e8f0', fontSize: '13px', textAlign: 'right', wordBreak: 'break-word' },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: '10px' },
  btn: {
    border: 'none',
    borderRadius: '10px',
    padding: '10px 14px',
    fontWeight: 700,
    cursor: 'pointer',
  },
  btnPrimary: { background: '#22c55e', color: '#052e16' },
  btnSecondary: { background: '#334155', color: '#e2e8f0' },
  hint: { marginTop: '12px', fontSize: '12px', color: '#64748b' },
};

export default ContactCreateConfirmationModal;
